import AppraiserProfile from "./AppraiserProfile";
import { connect } from "react-redux";
import {
  getAppraiserManagers,
  getAppraiserProfile,
  getCertificateList,
  getDesignationList,
  getStateList,
} from "actions/appraiser";
import { getAppraiserCounties } from "actions/appraiserCounties";
import { getUser } from "actions/user";

const mapStateToProps = (state) => ({
  appraiserProfile: state.appraiser.appraiserProfile,
  fetchingAppraiserProfile: state.appraiser.fetchingAppraiserProfile,
  fetchingAppraiserManagers: state.appraiser.fetchingAppraiserManagers,
  fetchingCertificateList: state.appraiser.fetchingCertificateList,
  fetchingDesignationList: state.appraiser.fetchingDesignationList,
  fetchingStateList: state.appraiser.fetchingStateList,
  isFetchingInternetUser: state.user.isFetchingInternetUser,
  internetUser: state.user.internetUser,
  fetchingAppraiserCounties: state.appraiser.fetchingCounties,
});

const mapDispatchToProps = (dispatch) => ({
  getAppraiserProfile(id) {
    dispatch(getAppraiserProfile(id));
    dispatch(getAppraiserCounties(id));
    dispatch(getAppraiserManagers());
    dispatch(getCertificateList());
    dispatch(getDesignationList());
    dispatch(getStateList());
  },
  getUser(internetUserId) {
    dispatch(getUser(internetUserId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppraiserProfile);
